export default "__VITE_ASSET__21770f99__"